<template>
  <div v-if="contractDiary" class="col-sm-12 editor-form p-2">
      <div
        v-if="!showElyHarjaReport"
        class="col-12 nopads"
      >
        <h3 class="editor-header">{{ $t('work_report.contract_diary') }}</h3>
        <div v-if="showContractSelection" class="row nopads">
          <div class="col-sm-6 pl-1 pr-1">
            <span class="span-title">{{ $t('contract_diary.date') }}</span>
            <input
              id="record_date"
              class="mt-1 form-control form-control-sm"
              :value="contractDiary.record_date ? timestampToDateInput(new Date(contractDiary.record_date).getTime()) : null"
              :max="today"
              type="date"
              @blur="updateRecordDate"
            >
          </div>
          <div class="col-sm-6 pl-1 pr-1 mt-2" style="margin-top: 2px">
            <open-contract-filter
              ref="contracts"
              :contract="contract"
              :from="now"
              :show-title="true"
              :show-company="false"
              :apply-padding="false"
              @contract-selected="setContract"
            />
          </div>
        </div>
        <div v-else>{{ new Date(contractDiary.record_date).toLocaleDateString() }}</div>
        <div
          v-if="elyVisible"
          class="row nopads"
        >
          <div
            class="col-sm-6 pl-1 pr-1"
            style="padding-top: .2em"
          >
            <span class="span-title">{{ $t('contract_diary.duty_officer') }}</span>
            <select
              id="duty_officer"
              v-model="dutyOfficer"
              class="form-select form-select-sm"
              size="sm"
              :state="dutyOfficer !== null"
              :disabled="!users || users.length === 0"
              @change="dataChanged = mounted"
            >
              <option :value="null">
                {{ $t('contract_diary.select_duty_officer') }}
              </option>
              <option
                v-for="option in users"
                :key="option.id"
                :value="option.id"
              >
                {{ option.first_name + ' ' + option.last_name }}
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="!elyVisible"
          class="row nopads"
        >
          <div
            class="col-sm-12 nopads pl-1 pr-1"
            style="padding-top: .2em"
          >
            <span class="span-title">{{ $t('contract_diary.supervisors') }}</span>
            <input
              id="supervisors"
              v-model="contractDiary.supervisors"
              class="no-margin form-control form-control-sm"
              type="text"
              @change="dataChanged = mounted"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 pr-1 pl-1">
            <span class="span-title">{{ $t('contract_diary.events') }}</span>
            <textarea
              id="events"
              v-model="contractDiary.events"
              class="form-control form-control-sm col-12"
              rows="7"
              @change="dataChanged = mounted"
            />
          </div>
          <div class="col-sm-6 pr-1 pl-1">
            <span class="span-title">{{ $t('contract_diary.deviations') }}</span>
            <textarea
              id="deviations"
              v-model="contractDiary.deviations"
              class="form-control form-control-sm col-12"
              rows="7"
              @change="dataChanged = mounted"
            />
          </div>
        </div>
        <Transition name="fade">
          <div
            v-if="elyVisible"
            class="nopads"
          >
            <div class="row">
              <div class="col-sm-6 pr-2">
                <div class="row nopads">
                  <span class="span-title">{{ $t('contract_diary.media_contacts_info_title') }}</span>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      v-model="contractDiary.media_contacts_received"
                      type="radio"
                      class="form-check-input"
                      :value="true"
                      @change="dataChanged = mounted"
                    >
                    <label
                      class="form-check-label"
                      for="bool_no"
                    >
                      {{ $t('common.yes') }}
                    </label>
                  </div>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      v-model="contractDiary.media_contacts_received"
                      type="radio"
                      class="form-check-input"
                      :value="false"
                      @change="dataChanged = mounted"
                    >
                    <label
                      class="form-check-label"
                      for="bool_no"
                    >
                      {{ $t('common.no') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 pr-2 pb-2 mt-4">
                <textarea
                  id="mediaContactsInfo"
                  v-model="contractDiary.media_contacts_info"
                  :disabled="!contractDiary.media_contacts_received"
                  class="form-control form-control-sm col-12"
                  rows="3"
                  @change="dataChanged = mounted"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 pr-2">
                <div class="row nopads">
                  <span class="span-title">{{ $t('contract_diary.customer_contacts_info_title') }}</span>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      v-model="contractDiary.customer_contacts_received"
                      type="radio"
                      class="form-check-input"
                      :value="true"
                    >
                    <label
                      class="form-check-label"
                      for="bool_no"
                    >
                      {{ $t('common.yes') }}
                    </label>
                  </div>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      v-model="contractDiary.customer_contacts_received"
                      type="radio"
                      class="form-check-input"
                      :value="false"
                      @change="dataChanged = mounted"
                    >
                    <label
                      class="form-check-label"
                      for="bool_no"
                    >
                      {{ $t('common.no') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 pr-2 pb-2 mt-4">
                <textarea
                  id="customerContactsInfo"
                  v-model="contractDiary.customer_contacts_info"
                  :disabled="!contractDiary.customer_contacts_received"
                  class="form-control form-control-sm col-12"
                  rows="3"
                  @change="dataChanged = mounted"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="row nopads">
                  <span class="span-title">{{ $t('contract_diary.citizen_contacts_info_title') }}</span>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      id="citizenContactsYes"
                      v-model="contractDiary.citizen_contacts_received"
                      class="form-check-input"
                      type="radio"
                      :value="true"
                      @change="dataChanged = mounted"
                    >
                    <label class="form-check-label">{{ $t('common.yes') }}</label>
                  </div>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      id="citizenContactsNo"
                      v-model="contractDiary.citizen_contacts_received"
                      class="form-check-input"
                      type="radio"
                      :value="false"
                      @change="dataChanged = mounted"
                    >
                    <label class="form-check-label">{{ $t('common.no') }}</label>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 pr-2 pb-2 mt-4">
                <textarea
                  id="citizenContactsInfo"
                  v-model="contractDiary.citizen_contacts_info"
                  class="form-control form-control-sm "
                  rows="3"
                  :disabled="!contractDiary.citizen_contacts_received"
                  :class="{'is-valid': contractDiary.citizen_contacts_info.length <= 500}"
                  @change="dataChanged = mounted"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 pr-2">
                <div class="row nopads">
                  <span class="span-title">{{ $t('contract_diary.authorities_assistance') }}</span>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      id="authoritiesAssistanceYes"
                      v-model="contractDiary.authorities_assistance"
                      class="form-check-input"
                      type="radio"
                      :value="true"
                      @change="dataChanged = mounted"
                    >
                    <label class="form-check-label">{{ $t('common.yes') }}</label>
                  </div>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      id="authoritiesAssistanceNo"
                      v-model="contractDiary.authorities_assistance"
                      class="form-check-input"
                      type="radio"
                      :value="false"
                      @change="dataChanged = mounted"
                    >
                    <label for="authoritiesAssistanceNo">{{ $t('common.no') }}</label>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 pr-2 pb-2 mt-4">
                <span class="span-title">{{ $t('contract_diary.hours') }}</span>
                <input
                  id="authoritiesInfoHours"
                  v-model="contractDiary.authorities_assistance_hours"
                  type="number"
                  min="0"
                  step="any"
                  class="form-control form-control-sm"
                  :disabled="!contractDiary.authorities_assistance"
                  :class="{'is-valid': !contractDiary.authorities_assistance || contractDiary.authorities_assistance_hours > 0}"
                  @change="dataChanged = mounted"
                >

                <span class="span-title">{{ $t('contract_diary.description') }}</span>
                <textarea
                  id="authoritiesInfo"
                  v-model="contractDiary.authorities_assistance_info"
                  class="form-control form-control-sm"
                  rows="3"
                  :disabled="!contractDiary.authorities_assistance"
                  :class="{'is-valid': !contractDiary.authorities_assistance || contractDiary.authorities_assistance_info.length > 1 && contractDiary.authorities_assistance_info.length < 500}"
                  @change="dataChanged = mounted"
                />
              </div>
            </div>

            <div class="row nopads">
              <div class="col-sm-6 pr-2">
                <div class="row nopads">
                  <span class="span-title">{{ $t('contract_diary.exceptional_weather') }}</span>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      id="exceptionalWeatherYes"
                      v-model="contractDiary.exceptional_weather"
                      class="form-check-input"
                      type="radio"
                      :value="true"
                      @change="dataChanged = mounted"
                    >
                    <label for="exceptionalWeatherYes">{{ $t('common.yes') }}</label>
                  </div>
                </div>
                <div class="row ms-2">
                  <div class="form-check">
                    <input
                      id="exceptionalWeatherNo"
                      v-model="contractDiary.exceptional_weather"
                      class="form-check-input"
                      type="radio"
                      :value="false"
                      @change="dataChanged = mounted"
                    >
                    <label for="exceptionalWeatherNo">{{ $t('common.no') }}</label>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 pr-2 pb-2 mt-4">
                <span class="span-title">{{ $t('contract_diary.time') }}</span>
                <date-time-picker
                  id="weatherTime"
                  v-model:date="contractDiary.exceptional_weather_time"
                  class="col-12 nopads"
                  :class="{ missing: contractDiary.exceptional_weather && !contractDiary.exceptional_weather_time, complete: !contractDiary.exceptional_weather || contractDiary.exceptional_weather_time }"
                  format="dd.MM.yyyy HH:mm"
                  :enable-time-picker="true"
                  :disabled="!contractDiary.exceptional_weather"
                  @change="dataChanged = mounted"
                />

                <span class="span-title">{{ $t('contract_diary.location') }}</span>
                <input
                  id="weatherLocation"
                  v-model="contractDiary.exceptional_weather_location"
                  class="form-control form-control-sm"
                  type="text"
                  :disabled="!contractDiary.exceptional_weather"
                  :class="{'is-valid': !contractDiary.exceptional_weather || contractDiary.exceptional_weather_location.length > 1}"
                  @change="dataChanged = mounted"
                >

                <span class="span-title">{{ $t('contract_diary.description') }}</span>
                <textarea
                  id="exceptionalWeatherInfo"
                  v-model="contractDiary.exceptional_weather_info"
                  class="form-control form-control-sm"
                  rows="3"
                  :disabled="!contractDiary.exceptional_weather"
                  :class="{'is-valid': !contractDiary.exceptional_weather || (contractDiary.exceptional_weather_info.length > 1 && contractDiary.exceptional_weather_info.length < 500)}"
                  @change="dataChanged = mounted"
                />

                <span class="span-title">{{ $t('contract_diary.additional_fleet_amount') }}</span>
                <input
                  id="additionalEquipmentAmount"
                  v-model="contractDiary.additional_fleet_amount"
                  class="form-control form-control-sm"
                  type="number"
                  step="1"
                  min="0"
                  :disabled="!contractDiary.exceptional_weather"
                  @change="dataChanged = mounted"
                >
              </div>
            </div>
          </div>
        </Transition>
        <div
          v-if="!elyVisible"
          class="col-12"
        >
          <!-- PHOTOS -->
          <div
            v-if="contractDiary.photos && contractDiary.photos.length > 1"
            class="row nopads text-center my-2"
          >
              <Flicking
                v-if="contractDiary.photos && contractDiary.photos.length > 0"
                ref="flicking"
                :options="options" :plugins="plugins" class="pointer nopads text-center"
                style="height: 15em;"
              >
                  <ImageView
                      v-for="photo in contractDiary.photos" :key="photo.id"
                      ref="image"
                      class="flicking-panel mx-1"
                      :contain="true"
                      :url="getPhotoUrl(contractDiaryPhotoUrl, photo)"
                      @click="openImage"
                      :controlSize="`sm`"
                  />
                  <template #viewport>
                      <div class="flicking-pagination flicking-pagination-bullets-container" style="margin-top: 2em"></div>
                  </template>
              </Flicking>
            </div>
          </div>
          <div
            v-else-if="contractDiary.photos && contractDiary.photos.length > 0"
            class="row nopads text-center"
          >
            <div class="col-12 nopads pointer">
              <div class="image-container">
                <ImageView
                  ref="image"
                  :img-size="'sm'"
                  :url="getPhotoUrl(contractDiaryPhotoUrl, contractDiary.photos[0])"
                  :contain="true"
                  :height="'300px'"
                  :control-size="'sm'"
                  @click="openImage"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!elyVisible" class="col-12 pl-1 pr-1">
              <!-- Photo editor-->
              <div class="col-12">
                  <!-- Show selected photos -->
                  <div
                      v-for="(file, index) in photos"
                      :key="index"
                      class="d-flex align-items-center justify-content-between mb-3"
                  >
                      <span>{{ file?.name || file }}</span>
                      <button
                          class="btn btn-outline-danger "
                          type="button"
                          @click="removePhoto(index)"
                      >
                          {{ $t('common.remove') }}
                      </button>
                  </div>

                  <!-- Hidden file input -->
                  <input
                      ref="photoInput"
                      type="file"
                      accept="image/jpeg,image/jpg,image/png"
                      class="visually-hidden"
                      @change="handlePhotoChange"
                  />
              </div>
          </div>
        <!-- Fullscreen photo -->
        <Transition name="fade">
          <fullscreen-image
            v-if="fullScreenPhotoData"
            :large-images="fullScreenPhotoData"
            :panel-index="panelIndex"
            @close="closePhoto"
          />
        </Transition>
        <div v-if="!showElyHarjaReport" class="col-sm-12 my-2 pt-3 text-end">
            <button
                v-if="!elyVisible"
                class="btn btn-outline-primary form-button"
                type="button"
                @click="triggerPhotoInput"
            >
                {{ $t('power_stations.add_photo') }}
            </button>

          <button
              v-if="showContractSelection"
              class="form-button btn btn-secondary"
              @click.stop="$emit('close')"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            class="form-button btn btn-success"
            :disabled="loading"
            @click.stop="submitContractDiary"
          >
            <span v-if="contractDiary.id > 0">
              {{ $t('contract_diary.save_contract_diary') }}
            </span>
            <span v-else>
              {{ $t('contract_diary.add_contract_diary') }}
            </span>
          </button>
        </div>
      <base-modal
          v-if="showConfirm"
          size="lg" hide-header-close title="Tallenna työmaapäiväkirja?" hide-footer>
          Haluatko tallentaa työmaapäiväkirjaan tekemäsi muutokset?
          <div class="col-12 my-3 d-flex justify-content-end">
              <button class="btn btn-secondary btn-sm form-button" @click="closeConfirm">{{ $t('common.cancel')}}</button>
              <button class="btn btn-success btn-sm form-button" @click="submitContractDiary">{{ $t('common.save')}}</button>
          </div>
      </base-modal>
        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {userHelper} from "@/components/mixins/UserMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {mapHelper} from "../mixins/MapMixin";
import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";
import {attachmentHelper} from "@/components/mixins/AttachmentMixin";
import ImageView from "@/components/view/ImageView.vue";
import "@egjs/flicking-plugins/dist/arrow.css";
import "@egjs/vue3-flicking/dist/flicking.css";
import {Pagination} from "@egjs/flicking-plugins";
import Flicking from "@egjs/vue3-flicking";
import FullscreenImage from "@/components/view/FullscreenImage.vue";
import ContractWorkDiary from "@/components/contract/external/ContractWorkDiary";
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";
import BaseModal from "../BaseModal.vue";

export default {
    name: 'ContractDiaryEditor',
    components: {BaseModal, FullscreenImage, ImageView, OpenContractFilter, Flicking, ContractWorkDiary, DateTimePicker},
    mixins: [workManagementHelper, restApi, userHelper, mapHelper, timeUtils, attachmentHelper],
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        reportListView: {
            type: Boolean,
            default: false
        },
        showElyFields: {
            type: Boolean,
            default: false
        },
        preSelectedContract: {
            type: Object,
            default: null
        },
        showContractSelection: {
            type: Boolean,
            default: true
        },
        showElyHarjaReport: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            contractDiary: null,
            dataChanged: false,
            mounted: false,
            showConfirm: false,
            options: {
                preventDefaultOnDrag: true,
                circular: false,
                defaultIndex: 1,
                panelsPerView: 3
            },
            photos: [],
            fullScreenPhotoData: null,
            plugins: [new Pagination({ type: 'bullet' })],
            contract: null,
            dutyOfficer: null,
            users: [],
            panelIndex: 0,
            elyVisible: false
        }
    },
    computed: {
        today: function() {
            const today = new Date();
            return today.toISOString().split('T')[0];
        },

        now() {
            return new Date().toISOString();
        },
    },
    watch: {
        modelValue() {
            this.contractDiary = JSON.parse(JSON.stringify(this.modelValue))
            this.contract = this.contractDiary.contract ? this.contractDiary.contract : this.preSelectedContract
            this.dutyOfficer = this.contractDiary.duty_officer ? this.contractDiary.duty_officer.id : null
            this.$nextTick(() => this.dataChanged = false)
        }
    },
    created() {
        this.fetchUsers()
        this.elyVisible = this.showElyFields
        this.contractDiary = JSON.parse(JSON.stringify(this.modelValue))
        this.contract = this.contractDiary.contract ? this.contractDiary.contract : this.preSelectedContract
        this.dutyOfficer = this.contractDiary.duty_officer ? this.contractDiary.duty_officer.id : null
    },
    mounted() {
        this.mounted = true
    },
    methods: {
        triggerPhotoInput() {
            this.$refs.photoInput?.click();
        },
        handlePhotoChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.photos.push(file);
            }
            // Clear input value so the same file can be selected again if needed
            event.target.value = '';
        },
        removePhoto(index) {
            this.photos.splice(index, 1);
        },

        isDataChanged() {
            return this.dataChanged
        },


        convertLocalToUTC(dateString) {
            const localDate = new Date(dateString);
            const utcOffset = localDate.getTimezoneOffset() * 60000; // Offset in milliseconds
            const utcDate = new Date(localDate.getTime() - utcOffset);

            return utcDate.toISOString(); // ISO string format for backend
        },
        setDefaultValues: function (value) {
            let contractDiary = JSON.parse(JSON.stringify(value))
            if (this.dutyOfficer) {
                const user = this.users.find(user => user.id === this.dutyOfficer);
                if (user) {
                    contractDiary.duty_officer = user;
                }
            }
            if(this.contract) {
                contractDiary.contract = this.contract
            } else {
                this.showAlert(this.$t('contract_diary.invalid_contract'))
            }
            if(this.contractDiary.record_date) {
                contractDiary.record_date = this.convertLocalToUTC(this.contractDiary.record_date);
            }
            return contractDiary
        },

        closeConfirm() {
            this.showConfirm = false
            this.$emit('close')
        },

        submitContractDiary: function () {
            this.showConfirm = false
            let jsonContractDiary = this.setDefaultValues(this.contractDiary)
            if (jsonContractDiary !== undefined) {
                this.loading = true
                if (this.contractDiary.id < 1) {
                    this.restAdd(this.contractDiaryUrl, jsonContractDiary, this.success, this.fail)
                } else {
                    this.restUpdate(this.contractDiaryUrl, jsonContractDiary, this.success, this.fail)
                }
            }
        },

        success: function (response) {
            var photos = this.getValidAttachments(this.photos)
            if (photos && photos.length > 0 && response) {
                this.uploadPhotos(photos, response)
            } else {
                this.loading = false
                this.dataChanged = false
                this.showAlert(this.$t('common.alert_update_success'), 'success')
                this.$emit('closeAndUpdate')
            }
        },

        fail() {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },

        setContract: function (contract) {
            this.contract = contract
            this.elyVisible = this.contract && this.contract.ely_contract
        },
        updateRecordDate: function (event) {
            if (event) {
                this.contractDiary.record_date = new Date(event.target.value)
            } else {
                this.contractDiary.record_date = undefined
            }
        },
        getPhotoUrl: function (baseUrl, photo) {
            return baseUrl + '/' + this.contractDiary.id + '/' + photo.id
        },
        openImage: function () {
            const flicking = this.$refs.flicking;
            const imageData = this.$refs.image;

            // Reset the full-screen photo data array
            this.fullScreenPhotoData = [];

            if (Array.isArray(imageData)) {
                // Handle multiple images
                imageData.forEach(src => {
                    this.fullScreenPhotoData.push(src);
                });
            } else if (imageData) {
                // Handle a single image (else block case)
                this.fullScreenPhotoData.push(imageData);
            }

            // Update the panel index
            if (flicking) {
                this.panelIndex = flicking.index;
            }
        },
        closePhoto() {
            this.fullScreenPhotoData = null
        },
        uploadPhotos: function (photos, response) {
            if (photos && photos.length > 0) {
                this.loading = true
                let formData = new FormData()
                formData.append('diary_id', response.id)
                photos.forEach(photoFile => {
                    if (photoFile !== undefined && photoFile !== null) {
                        formData.append('photos[]', photoFile)
                    }
                })
                this.restPostWithFile(this.contractDiaryPhotoUrl, {}, formData, this.photoSuccess, this.fail)
            }
        },
        onFileChange(event, index) {
            // Handle the file change event for the specific input
            const file = event.target.files[0]; // Get the first file selected
            if (file) {
                this.photos[index] = file; // Update the array with the selected file
            }
        },
        photoSuccess: function () {
            this.loading = false
            this.dataChanged = false
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.$emit('closeAndUpdate')
        },
        fetchUsers: function () {
            this.loading = true;
            this.users = []
            this.restFetchParams(this.userCompanyUrl, {active: 1}, this.handleUserResponse)
        },
        handleUserResponse: function (response) {
            if (response && response.data) {
                response.data.forEach(function (user) {
                    this.users.push({
                        last_name: user.last_name,
                        first_name: user.first_name,
                        id: user.id
                    })
                }, this)
            }
            this.loading = false
        },

        showConfirmDialog() {
            this.showConfirm = true
        }
    }
}
</script>
<style scoped>
.image-container {
    width: fit-content;
}
</style>
